import { useEffect, useState } from 'react'

const useCountdown = (fulltime: number) => {
  // const countDownDate = new Date(targetDate).getTime()

  const [countDown, setCountDown] = useState(fulltime)
  const [pause, setPause] = useState(false)

  let reset = (newtime: number) => setCountDown(newtime)

  useEffect(() => {
    const interval = setInterval(
      () => !pause && setCountDown(countDown - 1),
      1000
    )

    return () => clearInterval(interval)
  }, [countDown, pause])

  return { seconds: countDown, setPause, pause, reset }
}

const getReturnValues = (countDown: number) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24))
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  )
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

  return { days, hours, minutes, seconds }
}

export { useCountdown }
